export enum CountdownTimerTheme {
    RED = "red",
    YELLOW = "yellow",
    CARDS = "cards",
}

export type ICountdownTimer = Readonly<{
    body: string;
    mobile_body?: string | null;
    start_date: string;
    end_date: string;
    theme: CountdownTimerTheme;
}>;

export type ICountdownTime = Readonly<{
    days: number | null;
    hours: number | null;
    minutes: number | null;
    seconds: number | null;
}>;
